module.exports = "/build/web/svg/event/training.eb617573ee99000ecdd2bb2a4e8aa266.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/training.svg
// module id = 161
// module chunks = 24